










import Vue from "vue";

export default Vue.extend({
  name: "HealthError",
  props: { message: { type: String, required: true } }
});
